// Jumbotron
export const MIRRA_LOGO_WITH_TEXT = './img/mirra-logo.png'
export const JUMBOTRON_TRIANGLE_4X = './img/obj_triangle@4x.png'
export const PURLE_WHITE_ICON = './img/purle_white_icon.png'
export const MIRRA_LOGO_WHITE = './img/MIRRA_LOGO_WHITE.png'